import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-massive-report',
  templateUrl: './massive-report.component.html',
  styleUrls: ['./massive-report.component.scss']
})
export class MassiveReportComponent implements OnInit {

  @Input() dataMassiveReport: any;
  @Input() mobile: boolean = false;
  public searchString: string;
  public tableHeads = ['Tipo documento', 'Documento', 'Nombre', 'Valor total'];

  constructor() { }

  ngOnInit() {
  }

  filter(value: string) {
    this.searchString = value;
  }

}
